import {
  object,
  string,
} from 'yup';

export const validationSchema = object().shape({
  name: string().nullable().required('Name is required'),
});
